import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { FaWhatsapp } from 'react-icons/fa';
import './App.css';
import Header from './components/Header';
import PageTransition from './components/PageTransition';
import Home from './pages/Home';
import FeaturesPage from './pages/FeaturesPage';
import PricingPage from './pages/PricingPage';
import ContactPage from './pages/ContactPage';
import Footer from './components/Footer';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header />
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
            <Footer />
          </PageTransition>
          
          {/* WhatsApp Float Button */}
          <a 
            href="https://wa.me/908503070345" 
            className="whatsapp-float" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="WhatsApp ile iletişime geç"
          >
            <FaWhatsapp className="whatsapp-icon" />
          </a>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App; 